<label *ngIf="name" class="slider-label">{{ name }}</label>
<div class="w-100 d-flex" [tcTooltip]="tooltipText" [placement]="tooltipPlacement">
    <span *ngIf="showMinMax" class="align-self-center">{{ min }}</span>
    <mat-slider
        thumbLabel
        class="flex-grow-1"
        [(ngModel)]="value"
        [disabled]="isDisabled"
        [required]="isRequired"
        [min]="min"
        [max]="max"
        [step]="interval"
        [tickInterval]="showTicks | tickInterval: interval"
        [displayWith]="_precisionDisplayFn"
        (ngModelChange)="_onChangeCallback($event)"
        (blur)="_onTouchedCallback()"
        #control="ngModel"
    >
    </mat-slider>
    <span *ngIf="showMinMax" class="align-self-center">{{ max }}</span>
</div>
<mat-error *ngIf="control.hasError('required')">
    {{ 'validators.required' | translate: _locale.language }}
</mat-error>
<mat-error *ngIf="control.hasError('min')">
    {{ 'validators.min' | translate: _locale.language }}
</mat-error>
<mat-error *ngIf="control.hasError('max')">
    {{ 'validators.max' | translate: _locale.language }}
</mat-error>
